import { render } from "./HomeView.vue?vue&type=template&id=5f2527c0&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=5f2527c0&scoped=true&lang=scss"

import exportComponent from "D:\\workarea\\example\\景区旅游\\PC\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2527c0"]])

export default __exports__